const BillingState = {
  data: []
}

export default BillingState
